const WHATSAPP_NUMBER = '15551234567'; // ← replace with your real WhatsApp number (country code + number, no + or spaces)
const WHATSAPP_MESSAGE = 'Hi Still & Story! We would love to hear more about your wedding day.';

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
